import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { pushNotifications } from "../../../../redux/push-notification/action";
import { getFirebaseToken, messaging } from "../../../../service/firebase";
import { onMessage } from "firebase/messaging";
import ShippingList from "./shipment-list.component";


const CustomerHome = () => {
	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
	const [lat1, setLat1] = useState(0)
	const [lng1, setLng1] = useState(0)
	const [payload, setPayload] = useState({ notification: { title: '', body: '' } })

	const handleGetFirebaseToken = () => {
		getFirebaseToken()
			.then((firebaseToken) => {
				console.log(firebaseToken)
				dispatch(pushNotifications.create({
					url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/identity/platform-security/iam/subscribers`, entity: 'pushNotifications', jsonData: {

						Records: [
							{
								Context: {},
								Message: {
									DCMToken: firebaseToken
								}

							}
						]

					}
				}))
			})
			.catch((err) => console.error('An error occured while retrieving firebase token. ', err))
	}
	new Promise((resolve) => onMessage(messaging, (payload: any) => {
		setPayload(payload)
		console.log(payload)
		resolve(payload)
	}))
	return (
		<div className="flex flex-col items-center px-4 pt-10 pb-20">
			<div className='flex w-full justify-end items-end'>
				<button
					onClick={handleGetFirebaseToken}
					type='button'
					className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
				>
					GetFirebaseToken
				</button>

			</div>

			<div className="flex justify-between items-center mb-6 w-full">
				<p className="text-2xl font-semibold mb-2 mb-0"><FormattedMessage id="app.heading" /></p>
			</div>
			<div className="w-full flex items-center flex-col  lg:flex-row p-1">
				<div className="flex flex-row items-center bg-indigo-200 justify-center h-36 w-full m-4 ">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-indigo-200 w-1/3 h-12 fill-none mx-2">
						<path d="M11 22C10.1818 22 9.40019 21.6698 7.83693 21.0095C3.94564 19.3657 2 18.5438 2 17.1613C2 16.7742 2 10.0645 2 7M11 22V11.3548M11 22C11.3404 22 11.6463 21.9428 12 21.8285M20 7V11.5" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M7.32592 9.69138L4.40472 8.27785C2.80157 7.5021 2 7.11423 2 6.5C2 5.88577 2.80157 5.4979 4.40472 4.72215L7.32592 3.30862C9.12883 2.43621 10.0303 2 11 2C11.9697 2 12.8712 2.4362 14.6741 3.30862L17.5953 4.72215C19.1984 5.4979 20 5.88577 20 6.5C20 7.11423 19.1984 7.5021 17.5953 8.27785L14.6741 9.69138C12.8712 10.5638 11.9697 11 11 11C10.0303 11 9.12883 10.5638 7.32592 9.69138Z" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M5 12L7 13" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M16 4L6 9" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M20.1322 20.1589L22 22M21.2074 17.5964C21.2074 19.5826 19.594 21.1928 17.6037 21.1928C15.6134 21.1928 14 19.5826 14 17.5964C14 15.6102 15.6134 14 17.6037 14C19.594 14 21.2074 15.6102 21.2074 17.5964Z" stroke="#000000" stroke-width="1" stroke-linecap="round"></path>
					</svg>

					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start justify-center ">
						<div className="font-semibold text-3xl ">37</div>
						<div className="font-normal text-lg ">Active Shipments</div>
					</div>
				</div>
				<div className="flex flex-row items-center bg-green-200 justify-center h-36 w-full m-4 ">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-green-200 w-1/3 h-12 mx-2  fill-none ">
						<path d="M21 7V12M3 7C3 10.0645 3 16.7742 3 17.1613C3 18.5438 4.94564 19.3657 8.83693 21.0095C10.4002 21.6698 11.1818 22 12 22L12 11.3548" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M15 19C15 19 15.875 19 16.75 21C16.75 21 19.5294 16 22 15" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M8.32592 9.69138L5.40472 8.27785C3.80157 7.5021 3 7.11423 3 6.5C3 5.88577 3.80157 5.4979 5.40472 4.72215L8.32592 3.30862C10.1288 2.43621 11.0303 2 12 2C12.9697 2 13.8712 2.4362 15.6741 3.30862L18.5953 4.72215C20.1984 5.4979 21 5.88577 21 6.5C21 7.11423 20.1984 7.5021 18.5953 8.27785L15.6741 9.69138C13.8712 10.5638 12.9697 11 12 11C11.0303 11 10.1288 10.5638 8.32592 9.69138Z" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M6 12L8 13" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M17 4L7 9" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
					</svg>

					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start px-2 justify-center">
						<div className="font-semibold text-3xl">177</div>
						<div className="font-normal text-lg">Delivered Shipments</div>
					</div>
				</div>

				<div className="flex flex-row items-center bg-yellow-200 justify-center h-36 w-full m-4 ">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-yellow-200 w-1/3 h-12 mx-2  fill-none ">
						<path d="M11 22C10.1818 22 9.40019 21.6698 7.83693 21.0095C3.94564 19.3657 2 18.5438 2 17.1613C2 16.7742 2 10.0645 2 7M11 22L11 11.3548M11 22C11.3404 22 11.6463 21.9428 12 21.8285M20 7V11.5" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M18 18.0005L18.9056 17.0949M22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18Z" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M7.32592 9.69138L4.40472 8.27785C2.80157 7.5021 2 7.11423 2 6.5C2 5.88577 2.80157 5.4979 4.40472 4.72215L7.32592 3.30862C9.12883 2.43621 10.0303 2 11 2C11.9697 2 12.8712 2.4362 14.6741 3.30862L17.5953 4.72215C19.1984 5.4979 20 5.88577 20 6.5C20 7.11423 19.1984 7.5021 17.5953 8.27785L14.6741 9.69138C12.8712 10.5638 11.9697 11 11 11C10.0303 11 9.12883 10.5638 7.32592 9.69138Z" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M5 12L7 13" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M16 4L6 9" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
					</svg>

					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start justify-center">
						<div className="font-semibold text-3xl">5</div>
						<div className="font-normal text-lg">Pending Deliveries</div>
					</div>
				</div>
				<div className="flex flex-row items-center bg-orange-200 justify-center h-36 w-full m-4">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-orange-200 w-1/3 h-12 mx-2  fill-none ">
						<path d="M11 22C10.1818 22 9.40019 21.6698 7.83693 21.0095C3.94564 19.3657 2 18.5438 2 17.1613C2 16.7742 2 10.0645 2 7M11 22L11 11.3548M11 22C11.6167 22 12.12 21.8124 13 21.4372M20 7V12" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M16 15L19 18M19 18L22 21M19 18L16 21M19 18L22 15" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
						<path d="M7.32592 9.69138L4.40472 8.27785C2.80157 7.5021 2 7.11423 2 6.5C2 5.88577 2.80157 5.4979 4.40472 4.72215L7.32592 3.30862C9.12883 2.43621 10.0303 2 11 2C11.9697 2 12.8712 2.4362 14.6741 3.30862L17.5953 4.72215C19.1984 5.4979 20 5.88577 20 6.5C20 7.11423 19.1984 7.5021 17.5953 8.27785L14.6741 9.69138C12.8712 10.5638 11.9697 11 11 11C10.0303 11 9.12883 10.5638 7.32592 9.69138Z" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M5 12L7 13" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M16 4L6 9" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
					</svg>

					<div className="h-36 w-2/3 space-y-3 px-4 flex flex-col bg-white  items-start px-2 justify-center">
						<div className="font-semibold text-3xl">1</div>
						<div className="font-normal text-lg">Issues Reported</div>
					</div>
				</div>
			</div>
			{/* <div className="w-full flex items-center flex-col  lg:flex-row p-1">
				<div className="w-full flex flex-col px-3">
					<div className="text-xl font-semibold mb-4"><FormattedMessage id="app.card1" /></div>
					<div className="w-full bg-white border rounded-lg p-4">
						<canvas id="buyers-chart" height="400"></canvas>
					</div>
				</div>
				<div className="w-full p-3 my-3">
					<div className="text-xl font-semibold mb-4"><FormattedMessage id="app.card2" /></div>
					<div className="w-full bg-white border rounded-lg p-4 ">
						<canvas id="reviews-chart" height="400"></canvas>
					</div>
				</div>
			</div> */}
			<div className="w-full px-3">
				<div className="text-xl font-semibold mb-4">Recent shipments</div>
				<div className="w-full bg-white border rounded-lg p-4">
					<ShippingList />

				</div>
			</div>
		</div>
	);
};

export default CustomerHome;

